import styled from 'styled-components'

type Props = {
  children?: any
  wrapperStyle?: React.CSSProperties
  style?: React.CSSProperties
  className?: string
  id?: string
}

export const breakPoints = {
  mobile: 768,
}

export const mediaQuerys = {
  mobile: '@media only screen and (max-width: 1024px)',
  desktop: '@media only screen and (min-width: 1024px)',
}

export function Layout({
  children,
  wrapperStyle,
  style,
  className,
  ...props
}: Props) {
  return (
    <LayoutWrapper style={wrapperStyle}>
      <Content style={style} className={className} {...props}>
        {children}
      </Content>
    </LayoutWrapper>
  )
}

const LayoutWrapper = styled.div`
  margin: ${p => p.theme.pageContent.margin};
  position: relative;
  // overflow: hidden;
  box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
  border-radius: ${p => p.theme.pageContent.borderRadius};
  min-height: calc(100vh - 64px);
  max-height: auto;
  height: 100%;
  background-color: ${p => p.theme.pageContent.bg};
  display: flex;
  overflow: auto;
  width: calc(100dvw - 200px);
  ${mediaQuerys.mobile} {
    width: 100%;
    margin: 0;
    border-radius: 0;
    margin-top: 50px;
  }
`

const Content = styled.div`
  padding: 24px;
  flex: 1;
  width: 100%;
  ${mediaQuerys.mobile} {
    padding: 12px;
  }
`
export default Layout
